<template>
  <dl class="list list--definition list--clean">
    <template v-for="item in data">
      <dt :key="`dt-${item.key}`">{{ item.title }}</dt>
      <dd :key="`dd-${item.key}`">{{ item.value }}</dd>
    </template>
  </dl>
</template>

<script>
export default {
  name: 'PublisherInfoList',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
